import { Drawer, useTheme, useMediaQuery } from "@mui/material";
import React from "react";

import { SidebarDrawerContent } from "./SidebarDrawerContent";

interface AppSidebarProps {
  mobileOpen: boolean;
  onClose: () => void;
  collapsed: boolean;
  onCollapse: (collapsed: boolean) => void;
  defaultDrawerWidth: number;
  miniDrawerWidth: number;
  onMenuItemClick?: () => void;
}
export const AppSidebar: React.FC<AppSidebarProps> = (props) => {
  const {
    mobileOpen,
    onClose,
    collapsed,
    onCollapse,
    defaultDrawerWidth,
    miniDrawerWidth,
    onMenuItemClick,
  } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const canCollapse = !isMobile;
  const actualDrawerWidth =
    canCollapse && collapsed ? miniDrawerWidth : defaultDrawerWidth;

  // Personalizza questi colori
  const sidebarBgColor = "#1e293b"; // Sfondo sidebar (grigio scuro)
  const sidebarBorderColor = "#334155"; // Colore bordo

  return (
    <>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            width: defaultDrawerWidth,
            boxSizing: "border-box",
            borderRight: "none",
            bgcolor: sidebarBgColor,
          },
        }}
      >
        <SidebarDrawerContent
          collapsed={false}
          canCollapse={false}
          actualDrawerWidth={defaultDrawerWidth}
          onCollapse={onCollapse}
          onMenuItemClick={onMenuItemClick}
        />
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          width: actualDrawerWidth,

          overflowX: "hidden",
          "& .MuiDrawer-paper": {
            width: actualDrawerWidth,

            boxSizing: "border-box",
            bgcolor: sidebarBgColor,
            borderRight: `1px solid ${sidebarBorderColor}`,
            boxShadow: "none",
            overflowX: "hidden",
          },
        }}
        open
      >
        <SidebarDrawerContent
          collapsed={collapsed}
          canCollapse={canCollapse}
          actualDrawerWidth={actualDrawerWidth}
          onCollapse={onCollapse}
          onMenuItemClick={onMenuItemClick}
        />
      </Drawer>
    </>
  );
};
